'use strict';
var unitas = unitas || {};
const searchOpen = document.querySelector('#js-site-search-open');
const siteSearch = document.querySelector('#js-site-search');
const siteSearchInput = document.getElementById('js-site-search-input');
unitas.search = unitas.search || function () {
	function init() {
        if(searchOpen && siteSearch) {
            searchOpen.addEventListener('click', function() {
                openSearch();
            });
        }
	}
    function openSearch() {
        siteSearch.classList.add('site-search--open');
        unitas.darkoverlay.show();
        window.addEventListener('click', function(e){   
            if (document.getElementById('js-dark-overlay').contains(e.target)){
                closeSearch();
            } else {
                
            }
        });
        document.addEventListener('keydown', evt => {
            if (evt.key === 'Escape') {
                closeSearch();
            }
        });
    }

    function closeSearch() {
        siteSearch.classList.remove('site-search--open');
        unitas.darkoverlay.hide();
    }
	return {
		init : init
	};
}();